/**
 * Read-only SVG-дерево для тренажёра fano4.
 * Данные: {
 *   nodes: [{id,x,y,code?,letter?,is_leaf?,is_free?,show_code?}],
 *   edges: [{id,from,to}],
 *   width?, height?
 * }
 * На узлах — полные коды (не 0/1 на рёбрах).
 */
export default function TrainerFanoTree({
  tree,
  compact = false,
  className = '',
}) {
  if (!tree?.nodes?.length) return null;

  const width = tree.width || 360;
  const height = tree.height || 280;
  const nodesById = new Map(tree.nodes.map((n) => [n.id, n]));
  const r = compact ? 16 : 20;

  return (
    <svg
      className={`trainer-fano-tree ${compact ? 'is-compact' : ''} ${className}`.trim()}
      viewBox={`0 0 ${width} ${height}`}
      width="100%"
      height={compact ? 180 : Math.min(320, height)}
      role="img"
      aria-label="Дерево кодирования"
    >
      {(tree.edges || []).map((e) => {
        const a = nodesById.get(e.from);
        const b = nodesById.get(e.to);
        if (!a || !b) return null;
        return (
          <line
            key={e.id || `${e.from}-${e.to}`}
            x1={a.x}
            y1={a.y}
            x2={b.x}
            y2={b.y}
            className="trainer-fano-edge"
          />
        );
      })}
      {tree.nodes.map((n) => {
        const code = n.show_code === false ? '' : (n.code || '');
        const letter = n.letter || '';
        const label = letter
          ? (code ? `${letter}:${code}` : `${letter}:?`)
          : code;
        const fontSize = label.length > 5 ? (compact ? 9 : 10) : (compact ? 11 : 12);
        return (
          <g
            key={n.id}
            transform={`translate(${n.x},${n.y})`}
            className={[
              'trainer-fano-node',
              n.is_leaf ? 'is-leaf' : '',
              n.is_free ? 'is-free' : '',
            ].filter(Boolean).join(' ')}
          >
            <circle r={r} />
            {label ? (
              <text textAnchor="middle" dy="4" style={{ fontSize: `${fontSize}px` }}>
                {label}
              </text>
            ) : (
              <text textAnchor="middle" dy="4" className="trainer-fano-placeholder">
                ?
              </text>
            )}
          </g>
        );
      })}
    </svg>
  );
}
